import { async } from "q";
import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'

export const getCalendarioOperativoSemanal = async () => {
    const result = await PrivateInterceptor(`Global/CalendarioOperativo/semanal`, 'GET');
    return result;
}

export const getCalendarioOperativoMensual = async () => {
    const result = await PrivateInterceptor(`Global/CalendarioOperativo/mensual`, 'GET');
    return result;
}

export const getCalendarioOperativoSemanalPartida = async () => {
    const result = await PrivateInterceptor(`Global/CalendarioOperativo/semanalPartida`, 'GET');
    return result;
}
export const getCalendarioOperativoSemanalCalendar= async () => {
    const result = await PrivateInterceptor(`Global/CalendarioOperativo/semanalCalendar`, 'GET');
    return result;
}